import { HorizontalScrollView } from "@clipboard-health/ui-components";
import { TaxSeasonBannerContainer } from "@src/appV2/Accounts/TaxInformation/components/TaxSeasonBannerContainer";
import { ShiftDiscoveryGuidesBanner } from "@src/appV2/Knock/components/ShiftDiscoveryGuidesBanner";
import { ChartingCard } from "@src/appV2/redesign/Charting/Cards/ChartingCard";
import { ActiveReferralBanner } from "@src/appV2/Referral/Banners/ActiveReferralBanner";

import { ClipboardScoreBanner } from "../../ClipboardScore/components/Banners/ClipboardScoreBanner";
import { EarlyAccessBannerContainer } from "../../EarlyAccessFacilities/components/EarlyAccessBanner/EarlyAccessBannerContainer";
import { GuaranteedPayPricingSurveyEntrypoint } from "../../GuaranteedPay/GuaranteedPayPricingSurveyEntrypoint";
import { HolidayGiftEntrypoint } from "../../HolidayGift/Entrypoint";
import { FailedPayoutBannerContainer } from "../../Payments/FailedPayouts/components/FailedPayoutBannerContainer";
import { SetUpStripeAccountBannerContainer } from "../../Payments/Onboarding/components/SetUpStripeAccountBannerContainer";
import { StripeRestrictionBannerContainer } from "../../Payments/StripeRestriction/components/StripeRestrictionBannerContainer";
import { TravelShiftsEntrypoint } from "../../TravelShifts/TravelShiftsEntrypoint";
import { FavoriteWorkplaceBanner } from "../FavoriteWorkplaces/Banner/FavoriteWorkplaceBanner";
import { useGetFavoriteWorkplaceEntitlement } from "../FavoriteWorkplaces/useGetFavoriteWorkplaceEntitlement";
import { SHIFT_DISCOVERY_EARLY_ACCESS_PATH } from "../paths";
import { ForYouButton } from "../ShiftRecommendationsView/ForYouButton";
import { useShiftModalsDataContext } from "../useShiftModalsDataContext";

interface ListViewBannersProps {
  showClipboardScoreBanner?: boolean;
}

export function ListViewBanners(props: ListViewBannersProps) {
  const { showClipboardScoreBanner = true } = props;
  const { isEntitlementEnabled: isFavoriteWorkplacesEnabled } =
    useGetFavoriteWorkplaceEntitlement();
  const { baseNavigationPath } = useShiftModalsDataContext();

  const earlyAccessPath = `${baseNavigationPath}/${SHIFT_DISCOVERY_EARLY_ACCESS_PATH}`;

  return (
    <>
      <ForYouButton />
      <HorizontalScrollView
        stretch
        sx={{
          px: 5,
        }}
      >
        <GuaranteedPayPricingSurveyEntrypoint />
        <FailedPayoutBannerContainer sourceUI="shifts-tab" />
        <StripeRestrictionBannerContainer sourceUI="shifts-tab" />
        <SetUpStripeAccountBannerContainer sourceUI="shifts-tab" />
        <TravelShiftsEntrypoint />
        <EarlyAccessBannerContainer sourceUI="shifts-tab" navigationPath={earlyAccessPath} />
        <HolidayGiftEntrypoint />
        <ChartingCard />
        <TaxSeasonBannerContainer sourceUI="shifts-tab" />
        {isFavoriteWorkplacesEnabled && <FavoriteWorkplaceBanner />}
        <ShiftDiscoveryGuidesBanner filter={{ type: "shift-discovery-banner" }} />
        <ActiveReferralBanner />
        {showClipboardScoreBanner && <ClipboardScoreBanner showEmphasizedScore />}
      </HorizontalScrollView>
    </>
  );
}
